import classNames from 'classnames';
import { ISearchResultItem, ISearchResultResort, SearchCategory } from 'api/home/types';
import NoResutls from 'components/home/SearchPopup/NoResults';
import { Routes } from 'routes';
import SearchLink from 'components/home/SearchPopup/SearchLink';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { I18nKey } from 'i18n/types';

import { useShouldAdjustForSummer } from 'util/useShouldAdjustForSummer';
import styles from './styles.module.scss';

const formatVisibleTitle = (item: ISearchResultItem): string => {
  if (item.categoryUuid !== SearchCategory.resorts) {
    return item.title;
  }

  const resortItem = item as ISearchResultResort;
  const parts = [item.title];

  if (resortItem.regionTitle) {
    parts.push(resortItem.regionTitle);
  }

  if (resortItem.resort.country_code) {
    const countryCode = resortItem.resort.country_code.split('-')[0];
    parts.push(countryCode);
  }

  return parts.join(', ');
};

interface ISearchColumnProps {
  list: Array<ISearchResultItem>
  label: string
  query: string
  focusedIndex: number;
  shouldFollowFocusedLink: boolean;
}

const SearchResultsColumn: React.FC<ISearchColumnProps> = ({
  list, query, focusedIndex, shouldFollowFocusedLink,
}) => {
  const { t } = useOTSTranslation('common');
  const shouldAdjustForSummer = useShouldAdjustForSummer();

  return (
    <div className={classNames(styles.category, { [styles.categoryEmpty]: !list.length })}>
      <div className={styles.list}>
        {!list.length && (<NoResutls />)}
        {list.map((item, index) => {
          const isResort = item.categoryUuid === SearchCategory.resorts;
          const isRegion = item.categoryUuid === SearchCategory.regions;
          const isOther = item.categoryUuid === SearchCategory.other;
          const shouldShowCategory = item.categoryUuid !== SearchCategory.other;
          const category = item.categoryUuid.slice(0, -1);
          let href = '';

          if (isResort) {
            href = shouldAdjustForSummer ? Routes.resortTripPlanningOverview(item.resort) : Routes.resortSnowReport(item.resort);
          }
          if (isRegion) {
            href = Routes.regionSnowReport(item.region);
          }
          if (isOther) {
            href = item.href;
          }

          const isFocused = index === focusedIndex;

          return (
            <SearchLink
              key={item.uuid}
              query={query}
              className={classNames(styles.item, isFocused && styles.focused)}
              href={href}
              shouldFollowFocusedLink={isFocused && shouldFollowFocusedLink}
            >
              <span>{formatVisibleTitle(item)}</span>
              {shouldShowCategory && <span className={styles.tag}>{t(`searchResults.${category}` as I18nKey['common'])}</span>}
            </SearchLink>
          );
        })}
      </div>
    </div>
  );
};

export default SearchResultsColumn;
